const CustomerListData = 'customer-list-preset';

export const setCustomerListPreset = ({inquiry_id, inquiry_option_name}) => localStorage.setItem(CustomerListData, JSON.stringify({inquiry_id, inquiry_option_name}));
export const getCustomerListPreset = () => {
  const itemStr = localStorage.getItem(CustomerListData);
  if (itemStr) {
    return JSON.parse(itemStr);
  }

  return {};
};

export const removeCustomerListPreset = () => localStorage.removeItem(CustomerListData);
